import { gql } from '@apollo/client';

const GROUPS_QUERY = gql`
    query groups {
        groups {
            totalCount
            edges {
                node {
                    id
                    name
                    type
                    attributes {
                        id
                        dataFormat
                        dataType
                        name
                        value
                    }
                }
            }
        }
    }
`;

export default GROUPS_QUERY;
